import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'es', label: 'ES' },
  { code: 'it', label: 'IT' },
] as const;

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  return (
    <div className="flex items-center rounded-lg border border-border bg-muted p-0.5">
      {languages.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => i18n.changeLanguage(code)}
          className={`rounded-md px-2 py-1 text-xs font-medium transition-colors ${
            i18n.resolvedLanguage === code
              ? 'bg-primary text-white shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
